<template>
    <iframe :data-src="dataSrc" :data-api="dataApi" :data-method="dataMethod"  ref="chatbotIframe"
        :data-title="dataTitle" :data-open-icon="dataOpenIcon" :data-open-origin="dataOpenOrigin" :style-theme-color="styleThemeColor"></iframe>
</template>

<script setup>
import { nextTick,ref } from "vue"
import { embedChatbot } from "./index.js"
defineOptions({ name: "EmbedChatbot" })
const props = defineProps({
    dataSrc: {
        type: String,
    },

    dataApi: {
        type: String
    },
    dataMethod: {
        type: String
    },
    dataTitle: {
        type: String
    },
    dataOpenIcon: {
        type: String
    },
    dataOpenOrigin: {
        type: String
    },
    styleThemeColor: {
        type: String
    }
})
const chatbotIframe = ref(null)
nextTick(() => {
    embedChatbot(chatbotIframe.value, props.dataSrc, props.dataApi, props.dataMethod, props.dataTitle, props.dataOpenIcon, props.dataOpenOrigin,props.styleThemeColor)
})
</script>

<style lang="scss" scoped></style>
